<template>
  <div class="about">
    <div class="logo">
      <div class="roundBox"></div>
      <img :src="require(`@/assets${currentPageInfo.logoSrc}`)" alt="" />
    </div>
    <div class="rightDesc" :style="cur">
      <div class="descT">
        <p class="text">成立时间：{{ currentPageInfo.time }}</p>

        <p class="text" v-if="currentPageInfo.prods">
          产品：{{ currentPageInfo.prods }}
        </p>
        <p class="text" v-if="currentPageInfo.customs">
          客户：{{ currentPageInfo.customs }}
        </p>
        <p class="text" v-if="currentPageInfo.noDesc">
          {{ currentPageInfo.noDesc }}
        </p>
        <p class="text etext">Founded：{{ currentPageInfo.etime }}</p>

        <p class="text etext" v-if="currentPageInfo.eprods">
          Products：{{ currentPageInfo.eprods }}
        </p>
        <p class="text etext" v-if="currentPageInfo.ecustoms">
          Industry：{{ currentPageInfo.ecustoms }}
        </p>
        <p class="text etext" v-if="currentPageInfo.enoDesc">
          {{ currentPageInfo.enoDesc }}
        </p>
      </div>
      <div class="media">
        <div
          class="videoBox"
          v-if="
            !['Cross Huller', 'EXCELLO', 'LAMB', 'Honsberg'].includes(
              currentPageInfo.name
            )
          "
        >
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
        </div>
        <div class="imgs">
          <template v-if="currentPageInfo.banner.length">
            <slider ref="slider" :options="options">
              <!-- slideritem wrapped package with the components you need -->
              <slideritem
                v-for="(item, index) in currentPageInfo.banner"
                :key="index"
                :style="item.style"
              >
                <div
                  class="bannerItem"
                  :style="{
                    backgroundImage:
                      'url(' + require(`@/assets/imgs/banners/${item}`) + ')',
                  }"
                ></div>
              </slideritem>
            </slider>
          </template>
        </div>
      </div>
    </div>
    <div
      class="toBtn"
      v-if="
        ['Cross Huller', 'EXCELLO', 'LAMB', 'Honsberg'].includes(
          currentPageInfo.name
        )
      "
    >
      <img src="../assets/logos/gotomag.png" alt="" @click="toMAG" />
    </div>
    <div class="back" @click="toback">
      <img src="../assets/imgs/detail2.png" alt="back" />
    </div>
  </div>
</template>

<script>
import { slider, slideritem } from "vue-concise-slider";
import { dedtailList } from "../assets/json/detail";
export default {
  components: {
    slider,
    slideritem,
  },
  data() {
    return {
      options: {
        autoplay: "2000",
        loop: true,
        speed: 500,
      },
      addClass: "",
      addBackClass: "",
      currentPage: "",
      currentPageInfo: null,
      playerOptions: {
        muted: false,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        width: "100%",
        height: "268px",
        sources: [],
        poster: "/static/images/author.jpg",
      },
    };
  },
  mounted() {
    this.currentPage = this.$route.query.name;
    // eslint-disable-next-line no-debugger
    this.getCurrentInfo();
  },
  methods: {
    // eslint-disable-next-line vue/no-dupe-keys
    addClassName(type, name) {
      if (type == 1) {
        this.addClass = name;
      } else if (type == 2) {
        this.addBackClass = name;
      }
    },
    getCurrentInfo() {
      const newArr = JSON.parse(JSON.stringify(dedtailList));
      this.currentPageInfo = newArr.find((x) => x.name == this.currentPage);

      if (this.currentPageInfo.videoSrc) {
        this.currentPageInfo.videoSrc = require('../assets/video/' + this.currentPageInfo.videoSrc);
        this.playerOptions.sources = [
          { type: "video/mp4", src: this.currentPageInfo.videoSrc },
        ];
      } else {
        this.currentPageInfo.videoSrc = require('../assets/video/FFG.webm');
        this.playerOptions.sources = [
          { type: "video/webm", src: this.currentPageInfo.videoSrc },
        ];
      }
    },
    toMAG() {
      this.$router.push("/about?name=MAG");
      window.location.reload();
    },
    toback() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.about {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  object-fit: fill;
  background: url("../assets/imgs/detail3.png") no-repeat 0 0;
  position: relative;
  .toBtn {
    position: absolute;
    right: 30px;
    bottom: 0;
    transform: scale(0.5);
    transform-origin: center right;
    width: 874px;
    height: 436px;
    img {
      cursor: pointer;
    }
  }
  .logo {
    width: 633px;
    height: 614px;
    background: url("../assets/imgs/detail1-3.png") no-repeat center center;
    background-size: 80% 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 100px;
    top: 60px;
    .roundBox {
      width: 100%;
      height: 100%;
      background: url("../assets/imgs/detail1-2.png") no-repeat center center;
      position: absolute;
      animation: rotateImage 10s linear infinite;
      transition: All 1s ease-in-out;
    }
    img {
      width: 300px;
      height: 300px;
      aspect-ratio: 1 / 1;
      transform: scale(2);
    }
  }
  .rightDesc {
    position: absolute;
    left: 900px;
    top: 90px;
    font-size: 20px;
    font-weight: 700;
    color: #00ada9;
    p {
      margin-bottom: 18px;
      position: relative;
      &::before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -16px;
        display: block;
        content: "";
        width: 7px;
        height: 24px;
        background: #00ada9;
        border-radius: 5px;
      }
    }
    .etext {
      font-size: 18px;
    }
    .media {
      display: flex;
      align-items: center;
      margin-top: 100px;
      padding: 0 20px 0 0;
      box-sizing: border-box;
      .videoBox {
        flex: 1;
        height: 268px;
        width: 415px;
        video {
          width: 100%;
          height: inherit;
          object-fit: fill;
        }
      }
      .imgs {
        flex: 1;
        width: 415px;
        height: 268px;
        .bannerItem {
          width: 415px;
          height: inherit;
          background: url("../assets/imgs/banner1.jpg") no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
  }
  .back {
    position: absolute;
    left: 100px;
    bottom: 80px;
    width: 255px;
    height: 58px;
    transform: scale(0.7) !important;
    cursor: pointer;
    img {
      transition: All 200ms ease-in-out;
    }
    img:hover {
      transform: scale(1.1) !important;
    }
  }
}
.video-player {
  margin-right: 20px;
  box-sizing: border-box;
}
@keyframes rotateImage {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
